module.exports = "/_next/static/images/BusinessPlan-sm@2x-3823092429c9bc2546a9fa023e28640e.png";